import { useLayoutEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { LinearProgress, progressBarContainer } from './styles';

import { Location, OnboardingStatus } from '@cobliteam/common-types';

import { Analytics } from '@cobliteam/analytics';

import { Button, Typography } from '@cobliteam/ui/components';
import Banner, {
  BannerActions,
  BannerContent,
} from '@cobliteam/ui/components/Banner';

import useOnboardingStore from '../../store/useOnboardingStore';

const ProgressBar = () => {
  const history = useHistory();
  const progressBar = useOnboardingStore((state) => state.progressBar);
  const progressBarTitle = useOnboardingStore(
    (state) => state.progressBarTitle
  );
  const stepsTotal = useOnboardingStore(
    (state) => state.progressBarTourStepsTotal
  );
  const stepsIndex = useOnboardingStore((state) => state.tourStepsIndex);
  const setTourReset = useOnboardingStore((state) => state.setTourReset);
  const onboardingStepName = useOnboardingStore(
    (state) => state.onboardingStepName
  );
  const onboardingStatus = useOnboardingStore(
    (state) => state.onboardingStatus
  );
  const hasOnboarding = useOnboardingStore((state) => state.hasOnboarding);

  const handleSkip = () => {
    setTourReset();
    Analytics.track('Onboarding Dismissed', {
      context: `${onboardingStepName} step ${stepsIndex}`,
    });
  };

  const handleBack = () => history.push(Location.ONBOARDING_SETUP);

  const percentage = (stepsIndex / stepsTotal) * 100;

  useLayoutEffect(() => {
    if (onboardingStatus === OnboardingStatus.COMPLETED) return () => {};
    if (!progressBar) return () => {};
    const root = document.getElementById('container');
    root!.style.marginTop = hasOnboarding ? '67px' : '0';

    return () => {
      root!.style.marginTop = '0';
    };
  }, [onboardingStatus, progressBar, hasOnboarding]);

  if (!hasOnboarding) return null;

  if (!progressBar) return null;

  if (onboardingStatus === OnboardingStatus.COMPLETED) return null;

  return (
    <div className={progressBarContainer}>
      <Banner>
        <BannerContent>
          <Typography variant='description-title' color='white'>
            {progressBarTitle && <strong>Tarefa atual: </strong>}
            {progressBarTitle}
          </Typography>
        </BannerContent>
        <BannerActions>
          <Button
            variant='ghost'
            color='secondary'
            size='condensed'
            onClick={handleSkip}
          >
            Ignorar
          </Button>

          <Button
            variant='text'
            color='secondary'
            size='condensed'
            onClick={handleBack}
          >
            Voltar ao guia
          </Button>
        </BannerActions>
      </Banner>
      <LinearProgress
        variant='determinate'
        value={percentage}
        color='primary'
      />
    </div>
  );
};

export default ProgressBar;
